<div class="bv-listing-pagination__footer">
  <div class="bv-listing-pagination__page-size">
    <span>{{ "showing" | i18n }}</span>
    <select
      class="bv-listing-pagination__page-size-select"
      [value]="pageSize()"
      (change)="onPageSizeChange($any($event.target).value)"
      [attr.aria-label]="'showing' | i18n"
    >
      @for (size of pageSizeOptions(); track size) {
        <option [value]="size">{{ size }}</option>
      }
    </select>
    <span>{{ "of" | i18n }} {{ totalCount() }}</span>
  </div>

  <div class="bv-listing-pagination">
    <button
      type="button"
      class="bv-listing-pagination__btn"
      [disabled]="currentPage() <= 1"
      (click)="pageChange.emit(1)"
      [attr.aria-label]="'firstPage' | i18n"
    >
      &laquo;
    </button>
    <button
      type="button"
      class="bv-listing-pagination__btn"
      [disabled]="currentPage() <= 1"
      (click)="pageChange.emit(currentPage() - 1)"
      [attr.aria-label]="'previousPage' | i18n"
    >
      &lsaquo;
    </button>

    @for (page of paginationPages; track $index) {
      @if (page === "ellipsis") {
        <span class="bv-listing-pagination__ellipsis">...</span>
      } @else {
        <button
          type="button"
          class="bv-listing-pagination__page"
          [class.bv-listing-pagination__page--active]="page === currentPage()"
          (click)="pageChange.emit(page)"
        >
          {{ page }}
        </button>
      }
    }

    <button
      type="button"
      class="bv-listing-pagination__btn"
      [disabled]="currentPage() >= totalPages"
      (click)="pageChange.emit(currentPage() + 1)"
      [attr.aria-label]="'nextPage' | i18n"
    >
      &rsaquo;
    </button>
    <button
      type="button"
      class="bv-listing-pagination__btn"
      [disabled]="currentPage() >= totalPages"
      (click)="pageChange.emit(totalPages)"
      [attr.aria-label]="'lastPage' | i18n"
    >
      &raquo;
    </button>
  </div>
</div>
